import React from "react";
import BannerSection from "../Component/BannerSection";
import Layout from "../Component/Layout/Layout";
import ItemTabel from "../Component/CartView/ItemTabel";
import CheckoutOrderBox from "../Component/CheckoutOrderBox";

export default function CartView() {
  return (
    <div>
      <Layout>
        <BannerSection
          heading="Cart View"
          title="Home"
          image="/images/home_banner.jpg"
          description="Cart View"
          path="/cartview"
        />
        <ItemTabel />
        <div className="container">
          <div className="row pb-3">
            <div className="col-lg-7 col-xl-7 col-md-6 d-lg-block d-xl-block d-md-block d-none">
              <img
                src="images/cart_offer_img.jpg"
                alt="cart offer"
                className="img-fluid w-100 rounded"
              />
            </div>
            <div className="col-lg-5 col-xl-5 col-md-6 h-auto">
              <CheckoutOrderBox couponInput={false} />
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
